export default __webpack_public_path__ + "static/media/lc-bg.8d3febda.webp";